export default __webpack_public_path__ + "static/media/017-panda.218c3b52.svg";